interface ApiError {
  body: {
    error: string
    message: string
    statusCode: number
  }
}

export const isApiError = (error: any): error is ApiError =>
  error &&
  typeof error === 'object' &&
  'body' in error &&
  'message' in error.body
